module.exports = __webpack_public_path__ + "img/js.bdb5dc6a.png";